import { render, staticRenderFns } from "./PromoCardContainer.vue?vue&type=template&id=cd3227cc&lang=pug&"
import script from "./PromoCardContainer.vue?vue&type=script&lang=js&"
export * from "./PromoCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports